module.exports = __webpack_public_path__ + "static/media/notification.cf6ec84b.svg";